import { t } from "@/locales/config";
import { isDev, isMock } from "@/utils";

const SSO_SESSION_KEY = "blycare-sso-session";

export interface SsoSession {
  token: string;
  shop?: string | undefined;
  userId?: string | undefined;
}

/** ?token=...&shop=...&userId=... 是后端签发的单点登录链接，本地构建只用于展示。 */
function readSsoSession(): SsoSession | undefined {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || undefined;
  try {
    if (token) {
      const session: SsoSession = {
        token,
        shop: params.get("shop") || undefined,
        userId: params.get("userId") || undefined,
      };
      // 站内跳转会丢掉查询参数，存到 sessionStorage 让当前会话继续可用。
      window.sessionStorage.setItem(SSO_SESSION_KEY, JSON.stringify(session));
      return session;
    }
    const stored = window.sessionStorage.getItem(SSO_SESSION_KEY);
    return stored ? (JSON.parse(stored) as SsoSession) : undefined;
  } catch {
    return token ? { token } : undefined;
  }
}

export function getSsoSession() {
  return readSsoSession();
}

export function hasSsoSession() {
  return getSsoSession() !== undefined;
}

export async function getAdminAuthToken(): Promise<string> {
  if (isMock) return "mock-admin-token";
  if (isDev) {
    const token = import.meta.env.VITE_DEV_SHOP_TOKEN;
    if (!token)
      throw new Error("Development mode requires VITE_DEV_SHOP_TOKEN in apps/admin/.env.dev");
    return token;
  }

  const sso = getSsoSession();
  if (sso) return sso.token;

  if (!window.shopify) {
    throw new Error(t("AppBridgeUnavailable"));
  }
  return window.shopify.idToken();
}
